import { rootApi } from "../rootApi";

export const dealerStockReportApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getStocks: builder.query({
      query: (params) => ({
        url: "v1/dealerstockreport/dealer-stock-list",
        method: "GET",
        params
      }),
      transformResponse: (resp) =>
        resp?.data ?? { rows: [], totalCount: 0, pageItemCount: 0 },
      providesTags: (result) =>
        result?.rows
          ? [
              ...result.rows.map((r) => ({ type: "DealerStock", id: r.id })),
              { type: "DealerStock", id: "LIST" }
            ]
          : [{ type: "DealerStock", id: "LIST" }]
    }),

    getStockLogs: builder.query({
      query: (params) => ({
        url: "v1/dealerstockreport/dealer-stock-log-list",
        method: "GET",
        params
      }),
      transformResponse: (resp) =>
        resp?.data ?? { rows: [], totalCount: 0, pageItemCount: 0 },
      providesTags: (result, error, arg) => [
        { type: "DealerStockLog", id: arg?.partCode ?? "UNKNOWN" }
      ]
    }),
    exportPartsReturnToExcel: builder.query({
  query: ({ tabStatus = null, search = null, warehouseId = null, isActive = null, compressionType = null, LanguageId = null } = {}) => {
    const p = new URLSearchParams();
    if (tabStatus != null) p.set("TabStatus", tabStatus);
    if (search) p.set("Search", search);
    if (warehouseId != null) p.set("WarehouseId", warehouseId);
    if (isActive != null) p.set("IsActive", isActive);
    if (compressionType != null) p.set("CompressionType", compressionType);
    if (LanguageId != null) p.set("LanguageId", LanguageId);
    return { url: `v1/dealerpartsreturnprocess/exporttoexcel?${p.toString()}`, method: "GET" };
  },
  transformResponse: (resp) => {
    const data = resp?.data ?? {};
    return {
      fileBase64: data.fileBase64,
      fileName: data.fileName,
      contentType: data.contentType,
      recordCount: data.recordCount,
      fileSize: data.fileSize,
    };
  },
}),
  })
});

export const {
  useGetStocksQuery,
  useGetStockLogsQuery,
  useLazyExportPartsReturnToExcelQuery
} = dealerStockReportApi;
